var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1CallNotworking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76 76"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.2 16.3l-3-2.7L45.4 27l4.4 3.9A69.5 69.5 0 0143 40a88.9 88.9 0 01-8.2 8l-4.4-3.9-11.7 13.3 3 2.7a3.8 3.8 0 003.7.7h.1l.5-.3c6.1-2.8 14.9-9.8 21.1-16.9s12.1-16.7 14.1-23.1a.7.7 0 00.1-.5.1.1 0 00.1-.1 4 4 0 00-1.2-3.6zM18.7 32.8l5.7-5.6-5.7-5.7 2.8-2.8 5.7 5.6 5.6-5.6 2.9 2.8-5.7 5.7 5.7 5.6-2.9 2.8-5.6-5.6-5.7 5.6-2.8-2.8z"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Call_notworking.1494737b.svg";
export { SvgH1CallNotworking as ReactComponent };